<div class="d-flex justify-content-center min-vh-100 animated fadeIn" [class.neighborhood-background]="!largeContainer">
    <div class="row flex-column w-100">
        <app-auth-logo #authLogo></app-auth-logo>
        <div *ngIf="!authLogo.loading" [class.container]="signupForm && !largeContainer" [class.container-lg]="largeContainer">
            <ng-container *ngIf="signupForm">
                <form class="auth-form d-flex w-100" [formGroup]="formGroup" (ngSubmit)="submit()">
                    <div class="card">
                        <ng-container [ngTemplateOutlet]="signupForm.templateRef"></ng-container>

                        <div class="card-footer d-flex flex-column justify-content-center">
                            <app-spinner-button *ngIf="isSubmitting"
                                                [buttonClasses]="['mx-auto']">
                                {{ isHomeowner ? 'Sending Request' : 'Creating Account' }}
                            </app-spinner-button>
                            <app-button *ngIf="!isSubmitting"
                                        type="primary"
                                        [buttonClasses]="['mr-0']"
                                        [isSubmit]="true">
                                {{ isHomeowner ? 'Request to Join HOA' : 'Create an Account' }}
                            </app-button>

                            <div class="pt-4">
                                <div class="w-100 description-text">
                                    <div class="font-size-normal d-inline-block text-nowrap">
                                        <span>{{ 'By signing up, you agree to the' }}</span>
                                    </div>
                                    <div class="d-inline-block text-nowrap">
                                        <ng-container *ngTemplateOutlet="copyright"></ng-container>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </form>
            </ng-container>

            <ng-container *ngIf="signupStep">
                <div class="auth-form d-flex w-100">
                    <div class="card with-max-width">
                        <ng-container [ngTemplateOutlet]="signupStep.templateRef"></ng-container>

                        <div class="card-footer d-flex flex-column justify-content-center">
                            <app-button type="primary"
                                        [buttonClasses]="['mr-0']"
                                        [routeTo]="['/auth/login']">
                                {{ 'Back to Login' }}
                            </app-button>

                            <div class="pt-4">
                                <div class="w-100 description-text">
                                    <div class="font-size-normal d-inline-block text-nowrap">
                                        <span>{{ 'By signing up, you agree to the' }}</span>
                                    </div>
                                    <div class="d-inline-block text-nowrap">
                                        <ng-container *ngTemplateOutlet="copyright"></ng-container>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </ng-container>

            <ng-content></ng-content>

            <ng-container *ngIf="signupSubtext">
                <div class="card-subtext font-size-normal">
                    <ng-container [ngTemplateOutlet]="signupSubtext.templateRef"></ng-container>
                </div>
            </ng-container>

            <ng-container *ngIf="largeContainer">
                <div class="d-flex flex-row align-items-center justify-content-center font-size-normal pt-4 mt-5">
                    <span>{{ copyrightYear }}</span>
                    <ng-container *ngTemplateOutlet="copyright; context: { footer: true }"></ng-container>
                </div>
            </ng-container>
        </div>
    </div>
</div>

<ng-template #copyright let-footer="footer">
    <app-button type="link"
                [buttonClasses]="['mr-0']"
                [isInline]="true"
                (onClick)="openTermsOfService()">{{ 'Terms of Service' }}
    </app-button>
    <span>{{ footer ? '|' : 'and' }}</span>
    <app-button type="link"
                [buttonClasses]="['mr-0']"
                [isInline]="true"
                (onClick)="openPrivacyPolicy()">{{ 'Privacy Policy' }}
    </app-button>
</ng-template>
